import React, { useState, useEffect, useLayoutEffect } from 'react';
import axios from 'axios';
// 다국어
import { useTranslation } from 'react-i18next';
// @mui
import { Grid, Button, Container, Stack, Pagination } from '@mui/material';
import { styled } from '@mui/material/styles';

// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
// components


import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import MainViewPostList from './MainViewPostList';

// ----------------------------------------------------------------------

// const StyledSection = styled('div')(() => ({
//     display: 'flex',
//     justifyContent: 'center',
//     textAlign: 'center',
//     padding: '30px',
//     marginTop: 30,
// }));

const DivTable = styled('div')({
    display: 'flex',
    flexDirection: 'column'
})

const DivTableBody = styled('div')({
    display: 'flex',
    flexDirection: 'column'
})

const DivTableRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    padding: '2rem 0',
    '&:hover': {
        backgroundColor: '#f5f5f5'
    },
    borderBottom: '1px solid #ddd'
})

const DivTableCell = styled('div')({
    display: 'flex',
})

const DivTableTitle = styled('h4')({
    fontWeight: 500,
    marginBottom: '10px',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
})

const DivTableContent = styled('p')({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
})

// const StyledPagination = styled(Pagination)({
//     display: 'flex',
//     justifyContent: 'center',
//     marginTop: '40px',
//     '& .Mui-selected': {
//         backgroundColor: '#1a9ef8 !important',
//         color: '#fff !important',
//     },
//     Button: {
//         fontSize: '1.2rem',
//         padding: '1rem'
//     }
// })



// ----------------------------------------------------------------------

export default function MainNoticeTab() {


    const [value, setValue] = React.useState('1');
    // 다국어
    const { t, i18n } = useTranslation(['page']);

    // ----------------------------------------------------------------------


    // ----------------------------------------------------------------------

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>

            <Box sx={{ width: '100%', typography: 'body1' }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                            <Tab label={t('레인드롭')} value="1" style={{fontSize:'1.2rem'}}/>
                            <Tab label={t('슈가폴')} value="2" style={{fontSize:'1.2rem'}}/>
                        </TabList>
                    </Box>
                    <TabPanel value="1" style={{padding:0}}>
                        <DivTable sx={{ minWidth: 100,}} aria-label="simple table">
                            <DivTableBody>
                                <MainViewPostList data={{
                                    board_id: 26,
                                    page_number: 1,
                                    serch_query: "",
                                }} />
                            </DivTableBody>
                        </DivTable>
                    </TabPanel>

                    <TabPanel value="2" style={{padding:0}}>
                        <DivTable sx={{ minWidth: 100,}} aria-label="simple table">
                            <DivTableBody>
                                <MainViewPostList data={{
                                    board_id: 27,
                                    page_number: 1,
                                    serch_query: "",
                                }} />
                            </DivTableBody>
                        </DivTable>
                    </TabPanel>
                </TabContext>
            </Box>
            {/* <DivTable sx={{ minWidth: 650, borderTop: '2px solid #333' }} aria-label="simple table">
                    <DivTableBody>
                        {boardList.map((row) => (
                            <DivTableRow
                                key={row.id}
                                hover
                                onClick={() => { if (!viewPost) { setContentId(row.id); setViewPost(true); setPostList(false); } }}
                            >
                                <DivTableCell component="th" scope="row">{row.name}</DivTableCell>
                                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                    <DivTableTitle>{row.title}</DivTableTitle>
                                    <DivTableContent>{row.content}</DivTableContent>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', }}>
                                    <div style={{ padding: '20px', width: '200px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <DivTableCell>{row.userName}</DivTableCell>
                                    </div>
                                    <DivTableCell style={{ width: '120px', justifyContent: 'flex-end' }}>{row.createdAt}</DivTableCell>
                                </div>
                            </DivTableRow>
                        ))}

                    </DivTableBody>
                </DivTable>
                <StyledPagination count={totalPageCount} page={page} onChange={pageChange} color='primary' size="large" shape="rounded" style={{}} /> */}







        </>
    );
}

